import { gql } from '@grandvisionhq/graphql';

const bookAppointmentType = gql`
  fragment BookAppointmentType on AppointmentType {
    id
    name
    description
    duration {
      amount
      unit
    }
    ageGroup
  }
`;
const GET_BOOK_APPOINTMENT_TYPE = gql`
  query GetBookAppointmentType($id: ID!) {
    appointmentType(id: $id) {
      ...BookAppointmentType
    }
  }
  ${bookAppointmentType}
`;

export { GET_BOOK_APPOINTMENT_TYPE };
//# sourceMappingURL=get-book-appointment-type.js.map
